module.exports = __webpack_public_path__ + "components/forecast-table/static/icon-snowflake-3e8a7057f91796e864b37e4c0b6c4049.svg";